"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getTotalOrderBalance = void 0;
const getTotalOrderInvoiced_1 = require("./getTotalOrderInvoiced");
const getTotalOrderValue_1 = require("./getTotalOrderValue");
const getTotalOrderBalance = (order) => {
    if (!order)
        return 0;
    return (0, getTotalOrderValue_1.getTotalOrderValue)(order) - (0, getTotalOrderInvoiced_1.getTotalOrderInvoiced)(order);
};
exports.getTotalOrderBalance = getTotalOrderBalance;
